import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children }) => {
  const { accounts } = useMsal();
  return accounts.length > 0 ? children : <Navigate to="/login" />;
};

ProtectedRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element
  ]).isRequired
};

export default ProtectedRoute;
